module.exports = __webpack_public_path__ + "e7f1934603b1860a90b0e797c63ee3df.jpg";